<script>
import { mapGetters } from 'vuex';
import Badge from '../Badge';
import XmlChannelStatusXmlCard from './XmlChannelStatusXmlCard';
import XmlChannelStatusCvCard from './XmlChannelStatusCVCard';
import XmlChannelStatusPhCard from './XmlChannelStatusPHCard';
import XmlChannelStatusNyiCard from './XmlChannelStatusNyiCard';

export default {
  name: 'XmlChannelStatusCard',
  components: {
    Badge,
    XmlChannelStatusXmlCard,
    XmlChannelStatusCvCard,
    XmlChannelStatusPhCard,
    XmlChannelStatusNyiCard,
  },
  data() {
    return {
      types: {
        XML: 'xml-channel-status-xml-card',
        CV: 'xml-channel-status-cv-card',
        PH: 'xml-channel-status-ph-card',
      },
    };
  },
  props: {
    xmlChannel: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      badges: 'xmlChannelStatus/getBadges',
    }),
  },
};
</script>

<template>
  <v-card class="ma-2 xml-channel-status-card">
    <template v-if="xmlChannel.type">
      <component
        v-on="$listeners"
        :is="types[xmlChannel.type]"
        :xml-channel="xmlChannel"
      />
    </template>
    <template v-else>
      <xml-channel-status-nyi-card :xml-channel="xmlChannel"/>
    </template>
  </v-card>
</template>



// WEBPACK FOOTER //
// src/components/xmlChannelStatus/XmlChannelStatusCard.vue